import React from 'react'
import {
    createRegisterableComponentWithData,
    EditionLoader,
} from '@news-mono/web-common'
import { SpecialEditionHome } from './SpecialEditionHome'

export interface SpecialEditionHomeRouteProps {
    publicationTitle: string
    lazyloadImages?: boolean
    isTravelEdition?: boolean
    // set heading for travel editions explicitly
    heading?: string
    showFirstDivider?: boolean
}

export const NightlySpecialEditionHomeRegistration =
    createRegisterableComponentWithData(
        'nightly-special-edition-home',
        EditionLoader,
        (
            {
                publicationTitle,
                lazyloadImages,
                isTravelEdition,
                heading,
                showFirstDivider
            }: SpecialEditionHomeRouteProps,
            data,
            services,
        ) => {
            if (!data.loaded) return null
            const edition = data.result.documents?.[0]
            if (!edition) {
                services?.log?.error(
                    data,
                    'SpecialEditionHome: empty result',
                )
                return null
            }

            return (
                <SpecialEditionHome
                    edition={edition}
                    publicationTitle={publicationTitle}
                    lazyloadImages={lazyloadImages}
                    onEvent={services.onEvent}
                    isTravelEdition={isTravelEdition}
                    heading={heading}
                    showFirstDivider={showFirstDivider}
                />
            )
        },
    )
